"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RatingList = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _classnames4 = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _reactDeviceDetect = require("react-device-detect");
var _pluralTranslations = require("../../../../../../localization/pluralTranslations");
var _Tooltip = _interopRequireWildcard(require("../../../../../ui/Tooltip"));
var _styles = _interopRequireDefault(require("../../../../styles.scss"));
var _tripadvisor = _interopRequireDefault(require("./icons/tripadvisor.svg"));
var _booking = _interopRequireDefault(require("./icons/booking.svg"));
var _topHotels = _interopRequireDefault(require("./icons/topHotels.svg"));
var _turpravda = _interopRequireDefault(require("./icons/turpravda.svg"));
var _styles2 = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var SITE_ICONS = {
  tripadvisor: _tripadvisor.default,
  booking: _booking.default,
  tophotels: _topHotels.default,
  turpravda: _turpravda.default
};
var printRating = function printRating(rating) {
  return R.call(R.pipe(function (value) {
    return Math.round(value * 10) / 10;
  }, function (number) {
    return number.toFixed(1);
  }), rating);
};
var computeSumReviews = function computeSumReviews(ratings) {
  return R.call(R.pipe(R.map(R.prop('reviews')), R.sum), ratings);
};
var RatingListPure = function RatingListPure(_ref) {
  var averageRating = _ref.averageRating,
    className = _ref.className,
    itemClassName = _ref.itemClassName,
    title = _ref.title,
    sourceRatings = _ref.sourceRatings;
  var _useTranslation = (0, _reactI18next.useTranslation)('RESULT_CARD'),
    t = _useTranslation.t;
  var marksTranslation = (0, _pluralTranslations.usePluralMarksTranslation)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, title && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.ratingItemListTitle
  }, title), R.map(function (_ref2) {
    var ownRating = _ref2.rating,
      reviews = _ref2.reviews,
      site = _ref2.site,
      url = _ref2.url;
    return /*#__PURE__*/_react.default.createElement("a", {
      className: (0, _classnames4.default)(_styles2.default.ratingItem, itemClassName, _styles2.default['ratingItem--withHover']),
      href: url,
      key: site,
      rel: "noopener noreferrer",
      target: "_blank"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _styles2.default.ratingItemTitle
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: _styles.default.icon,
      dangerouslySetInnerHTML: {
        __html: SITE_ICONS[site]
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: _styles2.default.ratingLabel
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _styles2.default.ratingBar
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _styles2.default.ratingBarValue,
      "data-value": printRating(ownRating)
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: _styles2.default.ratingValue
    }, printRating(ownRating)), /*#__PURE__*/_react.default.createElement("div", {
      className: _styles2.default.ratingCount
    }, reviews, ' ', marksTranslation(reviews))));
  }, sourceRatings), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames4.default)(_styles2.default.ratingItem, _styles2.default.ratingItemAverage, itemClassName)
  }, averageRating ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.ratingItemTitle
  }, t('AVERAGE_RATING_TITLE')), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.ratingLabel
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.ratingBar
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.ratingBarValue,
    "data-value": averageRating
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.ratingValue
  }, averageRating), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.ratingCount
  }, computeSumReviews(sourceRatings), ' ', marksTranslation(computeSumReviews(sourceRatings))))) : /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.notEnough
  }, t('EMPTY_STATE_FOR_AVERAGE_RATING'))));
};
var RatingList = exports.RatingList = (0, _react.memo)(RatingListPure);
RatingList.propTypes = {
  averageRating: _propTypes.default.number,
  className: _propTypes.default.string,
  title: _propTypes.default.string,
  sourceRatings: _propTypes.default.arrayOf(_propTypes.default.shape({
    rating: _propTypes.default.number.isRequired,
    reviews: _propTypes.default.number.isRequired,
    site: _propTypes.default.oneOf(R.keys(SITE_ICONS))
  }))
};
var alignPopupConfig = {
  targetOffset: ['-100%', 0]
};
var Rating = function Rating(_ref3) {
  var averageRating = _ref3.averageRating,
    compact = _ref3.compact,
    enabledHover = _ref3.enabledHover,
    className = _ref3.className,
    isMobile = _ref3.isMobile,
    sourceRatings = _ref3.sourceRatings,
    labelClassName = _ref3.labelClassName;
  var wrapperRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    tooltipPlacement = _useState2[0],
    setTooltipPlacement = _useState2[1];
  var onPopupAlign = function onPopupAlign(popupContainerDOM) {
    if (!tooltipPlacement) {
      R.call(R.pipe(function ($container) {
        return $container.getBoundingClientRect().y;
      }, function (containerYPosition) {
        return containerYPosition >= popupContainerDOM.offsetHeight;
      }, function (isFilled) {
        return setTooltipPlacement(isFilled ? _Tooltip.PLACEMENTS.TOP_LEFT : _Tooltip.PLACEMENTS.BOTTOM_LEFT);
      }), wrapperRef.current);
    }
  };
  var onPopupVisibleChange = function onPopupVisibleChange(visible) {
    if (!visible) {
      setTooltipPlacement(undefined);
    }
  };
  var triggerJSX = /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames4.default)(_styles2.default.ratingLabel, _defineProperty({}, _styles2.default.hoverLabel, enabledHover), labelClassName)
  }, !R.isEmpty(sourceRatings) && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames4.default)(_styles2.default.ratingBar, _defineProperty({}, _styles2.default.isMobile, isMobile))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.ratingBarValue,
    "data-value": averageRating
  })), Boolean(averageRating) && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.ratingValue
  }, averageRating));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames4.default)(_styles2.default.ratingContainer, className, _defineProperty(_defineProperty({}, _styles2.default.compact, compact), _styles2.default.isMobile, isMobile)),
    ref: wrapperRef
  }, enabledHover ? /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    align: isMobile ? undefined : alignPopupConfig,
    content: /*#__PURE__*/_react.default.createElement(RatingList, {
      averageRating: averageRating,
      sourceRatings: sourceRatings
    }),
    className: _styles2.default.ratingPopup,
    overlayInnerStyle: _Tooltip.TOOLTIP_STYLES.RATING,
    enterDelay: _Tooltip.ENTER_DELAY.NOW,
    placement: tooltipPlacement,
    trigger: _reactDeviceDetect.isMobile ? _Tooltip.TRIGGERS.CLICK : _Tooltip.TRIGGERS.HOVER,
    showArrow: false,
    onPopupAlign: onPopupAlign,
    onVisibleChange: onPopupVisibleChange
  }, triggerJSX) : triggerJSX);
};
Rating.propTypes = {
  averageRating: _propTypes.default.number,
  className: _propTypes.default.string,
  compact: _propTypes.default.bool,
  isMobile: _propTypes.default.bool,
  enabledHover: _propTypes.default.bool,
  labelClassName: _propTypes.default.string,
  sourceRatings: _propTypes.default.arrayOf(_propTypes.default.shape({
    rating: _propTypes.default.number.isRequired,
    reviews: _propTypes.default.number.isRequired,
    site: _propTypes.default.oneOf(R.keys(SITE_ICONS))
  }))
};
Rating.defaultProps = {
  enabledHover: true
};
var _default = exports.default = (0, _react.memo)(Rating);